/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import MUIRichTextEditor from "mui-rte";
import { useAuth } from "../../../../../auth/auth";
import { saveJobNotesModel } from "../../../../../api/apiCall";
import { toast } from "react-toastify";
import styles from "./TextEditor.module.css"
import { Button } from "@mui/material";

const TextEditor = ({id, data, getEditJobModal, connection, week, year}: any) => {
    const {state} = useAuth();
    const [notesJson, setNotesJson] = useState(data.notesJson === "null" ? null : data.notesJson)
    const editorRef = useRef<any>(null);

    const handleSave = async (editorData?: any) => {
        const rawData = editorData || (editorRef.current ? await editorRef.current.save() : null);
        if (!rawData) return;

        let parsedData;
        try {
            parsedData = JSON.parse(rawData);
        } catch (err) {
            toast.error("Failed to save. Try again.");
            return;
        }

        const notes = parsedData.blocks.map((block: any) => block.text.trim()).join(" ");
        const hasContent = parsedData.blocks.some((block: any) => block.text.trim() !== "");

        const notesJson = hasContent ? JSON.stringify(parsedData) : null;

        if (notesJson) {
            try {
                JSON.parse(notesJson);
            } catch (err) {
                toast.error("Failed to save. Try again.");
                return;
            }
        }

        const response = await saveJobNotesModel(state.user?.token, id, notes || null, notesJson);
        if (response) {
            connection.invoke("EditJobNotesJson", `${week}-${year}`, id, notesJson);
            toast.success("Added Notes successfully");
        } else {
            toast.error("Something went wrong!");
        }

        getEditJobModal();
    };

    useEffect(() => {
        if(connection) {
            connection.on('EditJobNotesJson', (jobID: any, notesJson: any)=>{
                if(data.id === jobID) {
                    setNotesJson(notesJson)
                }
            })

            return () => {
                connection.off('EditJobNotesJson')
            }
        }
    }, [connection])

    return (
        <>
            <div className={styles.centerTextEditor}>
                <div className={styles.border}>
                    <MUIRichTextEditor
                        ref={editorRef}
                        label="Start typing..."
                        inlineToolbar
                        onSave={handleSave}
                        defaultValue={notesJson}
                    />
                </div>
            </div>
            <Button
                variant="contained" 
                style={{boxShadow: "none", margin: '0 auto', marginTop: 20, display: 'flex'}} 
                onClick={() => handleSave()}
            >
                Save Notes
            </Button>
        </>
    );
};

export default TextEditor;
